import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import NavbarComponent from "./components/NavbarComponent";
import Footer from "./components/Footer";
import Preloader from "./components/Preloader";
import FileNotFound from "./components/FileNotFound";
import ScrollToTop from "./pages/ScrollTop";
import ProtectedRoute from "./components/AdminDashboard/ProtectedRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Pages
import Home from "./pages/Home";
import Company from "./pages/Company";
import Products from "./pages/Products";
import ProductDetails from "./pages/ProductDetails";
import Blogs from "./pages/Blogs";
import BlogDetails from "./pages/BlogDetails";
import Events from "./pages/Events";
import Contact from "./pages/Contact";
import Research from "./pages/Research";
import Dashboard from "./pages/Dashboard";
import ColdChain from "./pages/ColdChain";
import AdminDashboard from "./components/AdminDashboard/AdminDashboard";
import LoginPage from "./components/AdminDashboard/LoginPage";
import { BsWhatsapp } from "react-icons/bs";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleLoad = () => {
      // small delay for smooth transition (optional)
      setTimeout(() => {
        setLoading(false);
      }, 500);
    };

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
    }

    return () => window.removeEventListener("load", handleLoad);
  }, []);

  if (loading) {
    return <Preloader />;
  }

  return (
    <Router>
      <MainLayout />
    </Router>
  );
}

function MainLayout() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const token = localStorage.getItem("token");
  const isAuthenticated = !!token;

  return (
    <>
      <ScrollToTop />

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />

      {!isAdminRoute && <NavbarComponent />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/our-company" element={<Company />} />
        <Route path="/products" element={<Products />} />
        <Route path="/product-details/:slug" element={<ProductDetails />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog-details/:slug" element={<BlogDetails />} />
        <Route path="/events" element={<Events />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/research-and-innovation" element={<Research />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/cold-chain-management" element={<ColdChain />} />
        <Route path="/admin/login" element={<LoginPage />} />

        <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
          <Route path="/admin/*" element={<AdminDashboard />} />
        </Route>

        <Route path="*" element={<FileNotFound />} />
      </Routes>

      {!isAdminRoute && <Footer />}

      {/* WhatsApp Floating Button */}
      {!isAdminRoute && (
        <a
          href="https://wa.me/919625404365"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-button"
        >
          <BsWhatsapp className="w-8 h-8" />
        </a>
      )}
    </>
  );
}

export default App;